import { ENV } from "@/env";

export const oAuthConfiguration = {
  clientId: ENV.oauthClientId,
  oauthAuthorizationUrl: `${ENV.baseUrlLogin}/api/v2/oauth/authorize`,
  oauthLogoutUrl: `${ENV.baseUrlLogin}/api/v2/oauth/logout`,
  codeChallengeMethod: "S256",
  oauthRedirectUrl: `${window.location.protocol}//${window.location.host}/oauth`,
};
